export enum BankCodeType {
  VNPAYQR = 'VNPAYQR',
  INTCARD = 'INTCARD',
}
